import React                from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle, withStyles } from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';

const styles = (_theme: Theme) => ({
    root: {
      width: '100%',
      display: 'flex',
    },
  });

interface IErrorPageProps {
}

type ErrorPageProps = WithStyle<ReturnType<typeof styles>, IErrorPageProps>;

class ErrorPage extends React.Component<ErrorPageProps> {
  constructor(props: ErrorPageProps) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <Typography variant='h5'>Error: Invalid Url.</Typography>
      </div>
    )} />;
  }
}

export default withStyles<IErrorPageProps, unknown>(styles, ErrorPage);
